import { useState, useRef, useEffect } from 'react';

const CustomDropdown = ({ 
  value, 
  onChange, 
  options = [], 
  width = "w-32",
  selectedBgColor = "bg-[#EDF2F4]",
  hoverBgColor = "hover:bg-[#EDF2F4]",
  borderColor = "border-[#BCD2E0]",
  placeholder = "Select an option"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      // Add a small delay to prevent immediate closing
      const timeoutId = setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside);
      }, 100);
      
      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isOpen]);

  const handleButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(prev => !prev);
  };

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const getDisplayValue = (option) => {
    if (typeof option === 'object' && option !== null) {
      return option.label || option.value || option.name || JSON.stringify(option);
    }
    return option;
  };

  const getOptionValue = (option) => {
    if (typeof option === 'object' && option !== null) {
      return option.value || option.id || option;
    }
    return option;
  };

  return (
    <div ref={containerRef} className="relative inline-block">
      <button
        type="button"
        onClick={handleButtonClick}
        className={`inline-flex justify-between items-center ${width} bg-white border ${borderColor} rounded-md px-3 py-1.5 text-sm font-medium text-gray-700`}
      >
        <span>{value ? getDisplayValue(value) : placeholder}</span>
        <svg 
          className={`h-4 w-4 transition-transform ${isOpen ? 'transform rotate-180' : ''}`}
          viewBox="0 0 20 20" 
          fill="currentColor"
        >
          <path 
            fillRule="evenodd" 
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
            clipRule="evenodd" 
          />
        </svg>
      </button>

      {isOpen && (
        <div 
          className={`absolute z-50 mt-1 ${width} bg-white rounded-md shadow-lg border ${borderColor}`}
          style={{ minWidth: '100%' }}
        >
          <div className="flex flex-col">
            {options.length > 0 ? (
              options.map((option, index) => (
                <button
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className={`w-full px-4 py-2 text-sm text-left ${
                    getOptionValue(option) === getOptionValue(value) ? selectedBgColor : `bg-white ${hoverBgColor}`
                  }`}
                >
                  {getDisplayValue(option)}
                </button>
              ))
            ) : (
              <div className="px-4 py-2 text-sm text-gray-500">No options available</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown; 